import { createFileRoute } from '@tanstack/react-router'
import { PerformanceClientesDashboard } from '../../../app/financial/performance-clientes'

export const Route = createFileRoute('/_auth/financial/performance-clientes')({
  component: PerformanceClientesDashboard
})
